// src/pages/support/GivingClubs.js
import React from "react";
import { Helmet } from "react-helmet";
import dummyImage from "../../assets/images/support/givingclubs.webp";
import CTASection from "../../components/CTASection"; // Add CTASection import
import styled from "styled-components"; // Add styled-components
import SupportOpportunity from "../../components/SupportOpportunity";

const GivingClubs = () => {
  const description = `
    Join one of Habitat for Humanity Buffalo's Giving Clubs and make a significant impact in our community. Members of our Giving Clubs receive special recognition and benefits for their ongoing support.
  `;

  const waysToSupport = [
    "Join the Builder's Club",
    "Join the Dream Maker's Club",
    "Join the Visionary's Club",
  ];

  return (
    <>
      <Helmet>
        <title>Giving Clubs - Habitat for Humanity Buffalo</title>
        <meta
          name="description"
          content="Join Habitat Buffalo's Giving Clubs and make a significant impact in our community. Receive special recognition and benefits for your ongoing support."
        />
      </Helmet>
      <Container>
        <SupportOpportunity
          title="Giving Clubs"
          image={dummyImage}
          description={description}
          waysToSupport={waysToSupport}
        />
        {/* Add CTA Section */}
        <CTASection
          title="Join Our Giving Clubs"
          description="Ready to make a lasting impact? Click the button below to join one of our Giving Clubs."
          buttonText="Get Started"
          buttonLink="/form/giving"
        />
      </Container>
    </>
  );
};

// Add necessary styled components
const Container = styled.div`
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
`;

export default GivingClubs;
